export type VoiceProviderDisplaySource = {
  provider: string;
  providerDisplayName?: string | null;
};

/** Label shown to end users; falls back to the real provider when no pseudonym is set. */
export function resolveVoiceProviderDisplayName(voice: VoiceProviderDisplaySource): string {
  const custom = voice.providerDisplayName?.trim();
  if (custom) return custom;
  return voice.provider || '';
}

/** Search matches display label and underlying provider (so admins can still find by real name). */
export function voiceMatchesProviderQuery(voice: VoiceProviderDisplaySource, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const display = resolveVoiceProviderDisplayName(voice).toLowerCase();
  const raw = (voice.provider || '').toLowerCase();
  return display.includes(q) || raw.includes(q);
}
